import { RootStoreContext } from '../stores/RootStore';
import React, {useContext, useState} from 'react';
import NotFound from "../layout/NotFound";
import { Redirect } from 'react-router-dom';

const Header = () => {

    const rootStore = useContext(RootStoreContext);
    const [status, setStatus] = useState(false);

    function onClickLogout(){
        window.location.href = "https://academic2.umn.ac.id/api/academic/user/logout"
        
        // window.location.href = "https://academic2.umn.ac.id?res=out"
    }

    return (
        <React.Fragment>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars"></i></a>
                    </li>
                </ul>
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="control-sidebar" onClick={onClickLogout} data-slide="true" href="#" role="button">
                            <i className="fa fa-sign-out"></i> Log out
                        </a>
                    </li>
                </ul>
            </nav>
        </React.Fragment>
    )
}


export default Header;